import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import GlobalWrapper from './GlobalStyle';
import { messagebox as MESSAGE_BOX_TYPES } from '../constants/theme';

const Box = styled.div`
    position: relative;
    font-family: ${props => props.theme.font.face.base};
    border-radius: ${props => props.theme.metrics.radius};
    background-color: ${props => props.theme.messagebox[props.type || 'warning'].background};
    color: ${props => props.theme.messagebox[props.type || 'warning'].text};
    box-sizing: border-box;
    width: 100%;
    line-height: 1.75;

    display: flex;
    margin: ${props => props.theme.metrics.spacing.half} 0 0;
    padding: ${props => props.theme.metrics.spacing.half};
    z-index: 0;

    p {
        margin: 0;
        font-size: ${props => props.theme.font.copy.medium};
        line-height: 1.5;
    }

    a {
        color: ${props => props.theme.messagebox[props.type || 'warning'].link};
    }

    &::before {
        content: '';
        padding: 5px;
        display: block;
        position: absolute;
        left: 3px;
        top: 3px;
        right: 3px;
        bottom: 3px;
        border-radius: ${props => props.theme.metrics.radius};
        border: 2px solid ${props => props.theme.messagebox[props.type || 'warning'].border};
        z-index: 0;
    }
`;

const ImageBox = styled.div`
    max-width: 33%;
    flex: 0 1 100%;
    z-index: 1;
    align-self: center;

    img {
        max-width: 100%;
    }
`;

const TextBox = styled.div`
    padding: 10px;
    font-size: ${props => props.theme.font.size.zeta};
    font-family: ${props => props.theme.font.face.brand};
    z-index: 1;
`;

const MessageBox = props => {
    const { imageUrl, imageAlt, children } = props;

    return (
        <GlobalWrapper>
            <Box {...props}>
                {imageUrl ? (
                    <ImageBox>
                        <img src={imageUrl} alt={imageAlt} />
                    </ImageBox>
                ) : (
                    ''
                )}
                <TextBox>{children}</TextBox>
            </Box>
        </GlobalWrapper>
    );
};

MessageBox.propTypes = {
    children: PropTypes.oneOfType([PropTypes.string, PropTypes.element]).isRequired,
    type: PropTypes.oneOf(Object.keys(MESSAGE_BOX_TYPES)),
    imageUrl: PropTypes.string,
    imageAlt: PropTypes.string,
};

export default MessageBox;
